import { Bot } from "lucide-react";
import { Button } from "../../components/ui";

/**
 * Botão "Integração Sisodonto" da tela de Caixa Geral, com o indicador de
 * robô online/offline. O botão abre o modal de integração por período.
 */
const IntegracaoSisodontoAcao = ({ agente, onAbrir }) => {
  const online = Boolean(agente.online);

  return (
    <div className="mb-6 flex flex-wrap items-center gap-3">
      <Button
        icon={Bot}
        onClick={onAbrir}
        disabled={!online}
        title={online ? "" : "Abra o robô no seu PC"}
      >
        Integração Sisodonto
      </Button>

      <span
        role="status"
        aria-live="polite"
        data-testid="estado-robo"
        className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-medium ${
          online ? "bg-green-100 text-green-800" : "bg-gray-100 text-gray-600"
        }`}
      >
        <span
          aria-hidden="true"
          className={`h-2 w-2 rounded-full ${
            online ? "bg-green-500" : "bg-gray-400"
          }`}
        />
        {online ? "Robô online" : "Robô offline"}
      </span>

      {!online && agente.carregado && (
        <span className="text-xs text-gray-500">
          Abra o robô no seu PC para integrar.
        </span>
      )}
    </div>
  );
};

export default IntegracaoSisodontoAcao;
